import "./style.less";
import { useTranslation } from "react-i18next";
import Paragraph from "antd/lib/typography/Paragraph";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { VuiButton, VuiFormCard, VuiHelmet } from "../../../../@vendor/components";
import { TickIllustration } from "../../../../components";

const AuthCreatePasswordSuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useMemo(() => {
    setTimeout(() => {
      navigate("/auth/login");
    }, 2000);
  }, []);

  return (
    <div id="auth-create-password-page">
      <VuiHelmet title={t("common.text.createPasswordSuccess")} />

      <VuiFormCard className="auth-create-password-wrapper">
        <TickIllustration style={{ marginBottom: 16 }} />

        <Paragraph>{t("auth.createPassword.success.description")}</Paragraph>

        <VuiButton
          buttonProps={{
            onClick: () => navigate("/auth/login"),
            type: "primary",
          }}
          label={t("common.button.login")}
        />
      </VuiFormCard>
    </div>
  );
};

export default AuthCreatePasswordSuccessPage;
